import React from 'react';
import PropTypes from 'prop-types';

import {
    Center,
    Col,
    Row,
} from '@zillow/zrs-comet';

import {
    Paragraph,
    Image,
    Spacer,
    Text,
} from '@zillow/constellation';

import SvgPeople from 'app/shared/images/people.svg';

import { StyledButton, StyledCard } from './StyledComponents';

const EmptyApplicationsCard = ({ displayInviteToApplyModal }) => (
    <StyledCard
        className="EmptyApplicationsCard"
        cardType="secondary"
    >
        <Center>
            <Spacer paddingY="sm">
                <Image src={SvgPeople} alt="background" />
            </Spacer>

            <Paragraph fontType="bodyHeading">
                No applications yet
            </Paragraph>

            <Spacer paddingY="xs">
                <Text fontType="bodySmall">
                    You can invite renters to apply or wait for renters to apply via your listing on
                    Zillow, Trulia, and HotPads
                </Text>
            </Spacer>

            <Spacer paddingTop="md">
                <Row>
                    <Col>
                        <StyledButton
                            buttonType="primary"
                            marginBottom="xs"
                            onClick={displayInviteToApplyModal}
                        >
                            Invite to apply
                        </StyledButton>
                    </Col>
                </Row>
            </Spacer>
        </Center>
    </StyledCard>
);

EmptyApplicationsCard.propTypes = {
    displayInviteToApplyModal: PropTypes.func,
};

EmptyApplicationsCard.defaultProps = {
    displayInviteToApplyModal: () => { },
};

export default EmptyApplicationsCard;
